import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerAsegurado = async (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_ASEGURADO, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        })
    })
}

export const registrarAsegurado = (idSolicitudMultiple, asegurado) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_ASEGURADO, atributos),
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        }),
        body: JSON.stringify(asegurado)
    })
}

export const actualizarAsegurado = (idSolicitudMultiple, asegurado) => {
    let atributos = [
        { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple },
        { campo: 'idAsegurado', valor: asegurado.idAsegurado }
    ]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_PUT_ASEGURADO, atributos),
        method: 'PUT',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        }),
        body: JSON.stringify(asegurado)
    })
}

export const cargarArchivoAdjunto = (idAsegurado, archivo) => {
    let atributos = [{ campo: 'idAsegurado', valor: idAsegurado }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_POST_CARGAR_ADJUNTOS, atributos),
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'Iam-id-token'              : 'Bearer ' + FuncionesServices.getIamToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : 'test'
        }),
        body: JSON.stringify(archivo)
    })
}